import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const MoneyIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M8.61932 47.1547V38.5439M20.1571 47.1547V31.5732M32.102 47.1549V35.4005M44.8614 47.1549V31.5732" stroke={props.htmlColor || "black"} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.75513 32.9405L19.7497 18.7259L31.6947 27.7467L41.78 18.3926" stroke={props.htmlColor || "#52C700"} strokeLinecap="round" strokeLinejoin="round"/>
      <ellipse cx="8.61932" cy="33.2821" rx="2.9184" ry="2.93863" fill={props.htmlColor || "#52C700"} strokeWidth="0" />
      <ellipse cx="19.75" cy="19.341" rx="2.9184" ry="2.93863" fill={props.htmlColor || "#52C700"} strokeWidth="0" />
      <ellipse cx="31.5591" cy="27.61" rx="2.9184" ry="2.93863" fill={props.htmlColor || "#52C700"} strokeWidth="0" />
      <path d="M45.021 10.6243C41.7854 10.6245 38.0383 14.3052 39.9211 16.5118C41.1521 17.9544 43.2345 15.9022 45.021 15.5365C44.4457 16.4568 43.1334 17.3704 43.1334 19.1711C43.1334 20.9717 44.9552 22.8099 48.2567 20.0957C51.5582 17.3815 52.0055 12.7025 52.2199 9.97306C50.8141 10.8713 48.2567 10.624 45.021 10.6243Z" fill={props.htmlColor || "#52C700"} />
    </SvgIcon>
  );
};

export default MoneyIcon;
